import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';
import RefreshRounded from '@mui/icons-material/RefreshRounded';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { useHistoryContextProvider } from 'features/history/providers/history-provider';

import './history-details-header.component.scss';

import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import { EmergencyAlarmProvider } from 'features/history/emergency-alarm/providers/emergency-alarm-provider';
import ResolveEmergencyAlarmButton from 'features/history/emergency-alarm/views/resolve-emergency-alarm-button.component';

const HistoryDetailsHeader = (): ReactElement => {
  const { t } = useTranslation('history');
  const { hasPermission } = usePermissionAuthorization();

  const { setCurrentSelectedItem, refresh } = useHistoryContextProvider();

  return (
    <div className="history-details-header">
      <Typography variant="h3">{t('details.title')}</Typography>
      <div className="buttons">
        {hasPermission(Permission.ReadTenant) && (
          <EmergencyAlarmProvider>
            <ResolveEmergencyAlarmButton />
          </EmergencyAlarmProvider>
        )}
        <IconButton className="refresh-button" onClick={refresh}>
          <RefreshRounded />
        </IconButton>
        <Divider orientation="vertical" flexItem />
        <IconButton
          aria-label="close"
          className="close-button"
          onClick={() => setCurrentSelectedItem(undefined)}
          data-testid="gatewayDetailsPopupCloseButton"
        >
          <Close />
        </IconButton>
      </div>
    </div>
  );
};

export default HistoryDetailsHeader;
